import { useEffect, useState } from "react";
import { useGetService } from "./useGetService";
import { API, DashboardTabs } from "../constants";
import { getUserData } from "../shared/utils";

// Third party
import _ from "lodash";
import { IServiceRequest, ITMDetail, ITmResponse } from "../types/global.types";
import { useArrivalDepartureData } from "./useArrivalDepartureData";
import { addDays } from "../utils/date.utils";
import moment from "moment";

export const useAssignedDetails = () => {
  const [rows, setRows] = useState<any>([]);
  const [isRowsLoading, setRowsLoading] = useState(false);

  const vendorId = getUserData()["cognito:username"];
  const today = addDays(new Date(), -1);
  // FETCH ALL DATA

  const {
    response: allResponse,
    isLoading: allResponseLoading,
    handleSearchApply,
    refreshingText,
  } = useArrivalDepartureData({
    startDate: today,
    endDate: addDays(new Date(), 90),
    selectedTab: DashboardTabs.ARRIVALS,
  });

  const startDate = moment().format("DD/MM/YYYY");

  // FETCH ASSIGNMENT
  const {
    response,
    isLoading,
    refetch: refetchAssinged,
  } = useGetService(
    `${API.CARNIVAL_ADMIN.GET_SERVICE_REQUEST_BY_VENDOR_ID}?vendorId=${vendorId}&startDate=${startDate}`
  );

  useEffect(() => {
    setRowsLoading(isLoading || allResponseLoading);

    if (!isLoading && !allResponseLoading) {
      const processedData = dataHandling(
        Array.isArray(allResponse) ? allResponse : allResponse?.data ?? [],
        Array.isArray(response?.data) ? response.data : []
      );
      setRows(processedData);
    }

    // Explicit clear when no assigned
    if (!isLoading && response?.data?.length === 0) {
      setRows([]);
    }
  }, [response, isLoading, allResponse, allResponseLoading]);
  const dataHandling = (
    resData: ITmResponse[],
    assignedRes: IServiceRequest[]
  ) => {
    // filter future dates (changed to >= today, since != today would exclude everything except exact midnight match)
    const filteredResData = assignedRes.filter((x) => {
      const arrivalDate = new Date(x.arrivalDate);
      return arrivalDate >= today;
    });

    const responseMap = new Map<string, any>();
    resData.forEach((res: { EmpId: string }) => {
      responseMap.set(res.EmpId, res);
    });

    console.log("filteredResData", filteredResData);

    return filteredResData.map((assigned) => {
      // if (assigned.isUnManifested === true) {
      //   return {
      //     ...assigned,
      //     isUnManifested: true,
      //     cancelled: false, // unmanifested isn't cancelled
      //   };
      // }

      const resMatch = responseMap.get(assigned.tmId);

      // cancelled if no match found
      const isCancelled = !resMatch;

      return {
        ...resMatch,
        ...assigned,
        cancelled: isCancelled,
      };
    });
  };

  const refetchData = () => {
    setRows([]);
    refetchAssinged(
      `${API.CARNIVAL_ADMIN.GET_SERVICE_REQUEST_BY_VENDOR_ID}?vendorId=${vendorId}`
    );
    handleSearchApply();
  };

  return {
    rows,
    isRowsLoading,
    refetchData,
  };
};
